<template>
  <v-sheet
    min-height="60"
    color="light-blue"
    class="d-flex flex-wrap">
    <v-overlay opacity="0.2" absolute :value="onloading">
      <v-progress-circular indeterminate color="white" width="3" size="30"></v-progress-circular>
    </v-overlay>
    <div v-if="child.length == 0" class="blank">
      <span v-if="$store.state.lang == 'cn'">暂无更多</span>
      <span v-else>NO MORE</span></div>
    <div
      v-if="child.length"
      class="item"
      v-for="i in child" 
      :key="i.id">
      <v-btn v-if="path == '/newslist' && i[$store.state.lang+'_title']" @click="item_click(i.id)" text color="white">
         <v-icon small class="mr-1">mdi-chevron-double-right</v-icon>
         {{i[$store.state.lang+'_title'].slice(0,8)}}...
      </v-btn>
      <v-btn v-else @click="item_click(i.id)" text small color="white">{{i[$store.state.lang+'_name']}}</v-btn>
    </div>
  </v-sheet>
</template>
<script>
export default{
  data(){
    return{
      navchild_io_api:'navchild/io/',
      child:[],
      onloading:false,
    }
  },
  props:{
    pid:{
      type:Number,
    },
    path:{
      type:String,
    },
  },
  methods:{
    item_click(x){
      this.$router.push({
        path:this.path,
        query:{
          flag:this.pid,
          ischild:'true',
          childid:x,
        },
      });
    },
    fetch(){
      this.onloading = true;
      let postdata = {};
      postdata.pid = this.pid;
      postdata.type = this.path;
      this.$axios.post(this.$store.state.baseurl + this.navchild_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.child = response.data.data;
                this.onloading = false;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
  watch:{
    pid(){
      this.fetch();
    },
  }
}
</script>
<style scoped>
.item{
  display:flex;
  align-items:center;
  height:30px;
  margin:10px;
  padding-left:2px;
  font-size:18px;
  font-weight:bold;
  border-left:3px solid #FF9800;
  border-radius:3px;
}
.blank{
  height:50px;
  width:100%;
  color:#fff;
  display:flex;
  justify-content:flex-start;
  align-items:center;
  padding-left:15px;
  font-size:12px;
}
</style>